import {formatNumbers, roundValue} from "@/helpers/format";

export default {
  filters: {
    format: function(value, columnFormat) {

      if(value === null) {
        return "N/A";
      }

      if (columnFormat === undefined || (value === undefined || value === ''))
      {
        return value;
      }

      if (columnFormat.type == 'integer')
      {
        return formatNumbers(value);
      }
      else if (columnFormat.type == 'float')
      {
        return formatNumbers(roundValue(value, columnFormat.precision), columnFormat.precision);
      }
      else if (columnFormat.type == 'percentage')
      {
        if (!isNaN(value))
        {
          return formatNumbers(roundValue(value, columnFormat.precision), columnFormat.precision);
        }
        else
        {
          return 0;
        }
      }
      else if (columnFormat.type == 'currency')
      {
        return formatNumbers(roundValue(value, columnFormat.precision), columnFormat.precision);
      }
      else
      {
        return value;
      }
    },
    formatCustom: function(value, type, precision = null, symbol = null) {

      if(value === null) {
        return "N/A";
      }

      if (type == 'integer')
      {
        return formatNumbers(value);
      }
      else if (type == 'float')
      {
        return formatNumbers(roundValue(value, precision), precision);
      }
      else if (type == 'percentage')
      {
        return formatNumbers(roundValue(value, precision), precision) + (symbol !== null ? symbol : '');
      }
      else if (type == 'currency')
      {
        return formatNumbers(roundValue(value, precision), precision) + (symbol !== null ? symbol : '');
      }
      else
      {
        return value + (symbol !== null ? symbol : '');
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/mixins/filterMixin.js